import React from 'react';
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet'
import { ThemedText, ThemedView } from "@app/theme";
import Button from "@sharedComponents/Button/Button";
import SystemErrorIcon from "../../../../../assets/Icons/SystemErrorIcon";
import gs from "@app/styles/globalStyles";

interface FailureCardProps {
    errorTitle: string;
    errorMessage: string;
    setShowFailureCard: (show: boolean) => void;
    colors: any;
    setRetriggerCamera: (reTriggerCamera: boolean) => void;
}

export const FailureCard: React.FC<FailureCardProps> = ({
                                                            errorTitle,
                                                            errorMessage,
                                                            setShowFailureCard,
                                                            colors,
                                                            setRetriggerCamera
                                                        }) => {
    return (
        <BottomSheetContainer
            isVisible={true}
            close={() => {
                setShowFailureCard(false);
            }}

            closeOnBackdropPress={true}
            borderTopRightRadius={10}
            borderTopLeftRadius={10}
            showCloseIcon={true}
            containerStyle={gs.setBg('#fefefe')}  dragComponent={undefined}>
            <ThemedView alignItems={"center"} padding={"lg"}>
              <ThemedView mt={"sm"}>
                <SystemErrorIcon color={"#DE4043"}/>
              </ThemedView>
                <ThemedText mt={"2xl"} variant={"h5s"} mb={"sm"}>
                    {errorTitle}
                </ThemedText>
                <ThemedView borderRadius={"sm"} backgroundColor={"bg-fill-warning"} padding={"md"} mb={"2xl"} width={"100%"}>
                    <ThemedText variant={"b3r"} textAlign={"center"}>
                        {errorMessage}
                    </ThemedText>
                </ThemedView>
                {
                    !errorMessage?.includes("completed") ? (
                        <Button
                            label="Retake selfie"
                            type="SOLID"
                            size='MD'
                            disabled={false}
                            handlePress={() => {
                                setRetriggerCamera(true)
                                setShowFailureCard(false)
                            }}
                            bg={colors['bg-action-primary']}
                            textColor={colors['text-primary']}
                        />
                    ) : (
                        <Button
                            label="Ok, got it!"
                            type="SOLID"
                            size='MD'
                            disabled={false}
                            handlePress={() => {
                                setShowFailureCard(false)
                            }}
                            bg={colors['bg-action-primary']}
                            textColor={colors['text-primary']}
                        />
                    )
                }
            </ThemedView>
        </BottomSheetContainer>
    );
};